import axios from 'axios';

export default {
  getPublicHolidays,
};

const publicHolidayBaseUrl = `${import.meta.env.VITE_TIME_REPORT_API_BASE_URL}/public_holidays`;

/**
 * Returns the public holidays list of the given year.
 *
 * @param {number} year   - The year to get public holidays.
 * @param {string} [zone] - Specific zone to get public holidays. Optional, default is 'metropole'.
 * @returns {Promise<Object>}
 */
function getPublicHolidays(year: number, zone: string) {
  return axios.get(`${publicHolidayBaseUrl}/${zone}/${year}`).then((result) => result.data);
}
